

    import {Component, Prop, Vue} from "vue-property-decorator";

    @Component({})
export default class spikePart2Item extends Vue {
  @Prop() items: any;
}
